import { LocalStorage } from "quasar";
import axois from "axios";
import { BaseApiService } from "./api-base";

export class DsApiService extends BaseApiService {
  constructor(host: string) {
    super("ds");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  transform_text(texts: any, c = "html") {
    // c : html | voice | yandex
    const method = `${this.url}/transformText/${c}`;
    const body = { texts };
    return this.http.post(method, body).then((response) => response.data);
  }

  //#region DEPRICATED
  resetDialog() {
    const method = `${this.url}/resetDialog`;
    const body = {
      dialogId: this.dialogId,
      app_ref: this.app_ref,
    };
    return this.http.post(method, body).then((response) => response.data);
  }
  //#endregion

  msg_hello_dataset(state: any) {
    (window as any).ws.send_event("initHello", {
      dialog_id: LocalStorage.getItem("dialogId"),
      chanel: "dataset",
      wf_ref: this.settings.datasetWfRef,
      state,
    });
  }

  proceedQuestion(data: {
    guid: string;
    text?: string;
    audio_guid?: string;
    s?: any;
  }) {
    const path = `${this.url}/proceedQuestion`;
    const body = {
      app_ref: this.app_ref,
      wf_ref: this.settings.wfRef || undefined,
      chanel: "web",
      dialogId: LocalStorage.getItem("dialogId"),
      message_id: data.guid,
      text: data.text?.trim(),
      audio_guid: data.audio_guid,
      init_state: data.s || undefined,
    };
    return this.http.post(path, body).then((response) => response.data);
  }

  wsSendMessage(data: {
    guid: string;
    text: string;
    audio_guid: string;
    type: string;
    s: any;
    wf_ref: string;
    chanel: string;
    source: string;
  }) {
    data.wf_ref = data.wf_ref || this.settings.wfRef || undefined;
    data.s.audio_guid = data.audio_guid;
    (window as any).ws.send_message({
      message_id: data.guid,
      dialog_id: LocalStorage.getItem("dialogId"),
      text: data.text.trim(),
      login: null,
      chanel: data.chanel,
      source: data.source,
      state: data.s || {},
      type: data.type,
      wf_ref: data.wf_ref,
      need_sys_answ: data.s.needSysAnsw,
    });
  }
}
